import { requestAssetReport } from './assetReportRequest';
import Vue from 'vue';
import ModalAssetReportImages from '@/components/Modal/ModalAssetReportImages.vue';

function chooseImages(assets) {
  return new Promise(resolve => {
    const Dialog = Vue.extend(ModalAssetReportImages);
    const dialog = new Dialog({ propsData: { assets } });
    const finish = selection => {
      dialog.$destroy();
      if (dialog.$el.parentNode) dialog.$el.parentNode.removeChild(dialog.$el);
      resolve(selection);
    };
    dialog.$once('confirm', finish);
    dialog.$once('cancel', () => finish(null));
    dialog.$mount();
    document.body.appendChild(dialog.$el);
  });
}

// Read available images through the same export endpoint: same assets and permissions.
export async function exportAssetReport(model, options) {
  const request = extra => model.request({
    ...options,
    ...(options.method === 'POST'
      ? { data: { ...options.data, ...extra } }
      : { query: { ...options.query, ...extra } })
  });
  return requestAssetReport(request, chooseImages, Vue.prototype.$loading);
}
